import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import { RefObject } from "react";
import { UserForRanking } from "../../../types";
import { PcListArea } from "./PcListArea";
import { SpListArea } from "./SpListArea";

export function FriendList({
    users,
    loading,
    pcScrollableContainerRef,
    isPcMode,
    screenHeight,
}: {
    users: UserForRanking[];
    loading?: boolean;
    pcScrollableContainerRef: RefObject<HTMLDivElement>;
    isPcMode: boolean;
    screenHeight: number;
}) {
    const c = useStyles();

    return (
        <Card className={c.friendsCard} elevation={2}>
            <Card className={c.friendsTitle}>Friends: {users.length}</Card>

            {isPcMode ? (
                <PcListArea
                    users={users}
                    loading={loading}
                    scrollableContainerRef={pcScrollableContainerRef}
                    screenHeight={screenHeight}
                />
            ) : (
                <SpListArea
                    users={users}
                    loading={loading}
                    pcScrollableContainerRef={pcScrollableContainerRef}
                />
            )}
        </Card>
    );
}
const useStyles = makeStyles(theme => ({
    friendsCard: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        border: "solid 1px #047c28",
        fontWeight: "bold",
        overflow: "hidden",
        backgroundColor: theme.palette.grey[100],
        position: "relative",
    },
    friendsTitle: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "large",
        margin: "-5px 5px 5px -5px",
        padding: "3px 10px",
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        backgroundColor: "#047c28",
        color: "white",
        fontWeight: "bold",
        position: "absolute",
        top: 4,
        left: 4,
        zIndex: 10,
    },
    lazyPlaceHolder: { height: 50, margin: 5 },
}));
